import { RowDto, TableDto } from '../../system-configuration/table-editor';

import { ColumnValueView } from './column-value-view.model';

export interface TableEditorState {
    pending: {
        create?: boolean;
        delete?: number /* row index in rows array */;
    };

    tables?: TableDto[];
    table?: TableDto;
    rows?: RowDto[];
    rowViews?: ColumnValueView[];

    lastSaveSucceeded?: boolean;
    message?: string;
}

export const defaultState = (): TableEditorState => ({
    pending: {},
});
